// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext} from 'react';
import styles from './maintenance.module.less';
import {oculus_img_url} from '../../../../hola/pub/ui/oculus_img_url';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import Time from '../../img/icons/16/time.svg';
import cn from 'classnames';

export const Maintenance = ()=>{
    const top_sub_title = 'We’re currently performing an important system'+
        ' migration to improve your experience. During this time, the site'+
        ' will be temporarily unavailable.';
    const bottom_title = <>We appreciate your patience and understanding as we
      work to complete this upgrade as quickly as possible. Thank you for
      your continued support.<br/><br/><i>Please check back soon.</i></>;
    const {theme} = useContext(Settings_context);
    return <div className={styles.maintenance}>
      <img src={oculus_img_url(`maintenance.svg`)}/>
      <div className={styles.content}>
        <div className={styles.top}>
          <h3>Maintenance in Progress</h3>
          <p className={cn(theme.p18, theme.med)}>{top_sub_title}</p>
        </div>
        <div className={styles.badge}>
          <Time/>
          <p className={cn(theme.p14, theme.med)}>
            Estimated Downtime: <span className={theme.bold}> 2-3 hours</span>
          </p>
        </div>
        <div className={styles.bottom}>
          <p className={cn(theme.p14, theme.med)}>
            {bottom_title}
          </p>
        </div>
      </div>
    </div>;
};
